module.exports = __webpack_public_path__ + "media/images/cleaning/pro1@3x-6c79e963f6492c0f7107129e3c70e59a.jpg";